/**
 * Button color definitions
 *
 * NOTE: This file is a legacy barrel kept for the default Colors export in colors.ts.
 * The canonical source of truth for button colors is ui.colors.ts.
 * Always keep this file in sync with ui.colors.ts buttonColors.
 */
import { palette, createColor } from './palette.colors';

export const buttonColors = {
  /** Default solid fill — matches blue theme primary (#005FCC via theme resolver) */
  primary: createColor(palette.blue.primary),
  primaryText: createColor(palette.gray.white),

  /** Secondary / outlined button — white bg */
  secondary: createColor(palette.gray.white, palette.gray.white),
  secondaryText: createColor(palette.gray.offBlack, palette.dark.textAlt),
  secondaryBorderColor: createColor(palette.blue.selectedBorder, palette.blue.selectedBorder),
  secondaryHoverBG: createColor(palette.blue.selectedItemBG, palette.dark.border),
  secondaryPressedBG: createColor(palette.blue.pale, palette.dark.borderLight),

  /** Disabled state — background #CED8E3, text white */
  disabled: createColor(palette.gray.disabled),
  disabledText: createColor(palette.gray.slate),
  ctaDisableBG: createColor(palette.gray.tabDisabled, palette.dark.overlay),   // #CED8E3
  ctaDisableText: createColor(palette.gray.white, palette.gray.zinc),          // #FFFFFF

  borderColor: createColor(palette.gray.mainBorder, palette.dark.techBorder),
  CTAIcon: createColor(palette.gray.black, palette.dark.text),
  CTAText: createColor(palette.gray.darkest, palette.dark.text),
};